import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';

//Context
import { useAuth } from '../../../context/auth';

// Components
import MainCard from '../../../components/MainCard/MainCard';
import { Row } from 'reactstrap';
import CardRelatorio from '../components/CardRelatorio';

export default function RelatorioGeradoresSemColeta({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetasNaoRealizadas = [
        { value: "CNPJ", objectValue: "cnpj", col: "4" },
        { value: "DATA", formatDateSemHora: true, objectValue: "data", col: "4" },
        { value: "RAZÃO SOCIAL", objectValue: "razaoSocial", col: "12" },
        { value: "TRANSPORTADOR", objectValue: "transportador", col: "12" },
        { value: "ENDEREÇO", objectValue: "endereco", col: "12" }
    ];


    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
    });


    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} width={250} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de geradores sem coletas</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected && <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>}
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Lista de Coletas Não Realizadas</h5>
                    <CardRelatorio
                        headers={headersColetasNaoRealizadas}
                        items={dadosRelatorio}
                    />
                </div>
            </div>
        </MainCard>
    );
}
